import React, { Fragment } from 'react';
import { TransitioningPageWrapper } from 'components/Shared';
import PageTransitionContainer from 'components/Mobile/PageTransitionContainer';
import { StackedArea, StackableContentProvider, } from 'components/Shared/StackedContent/StackableContentContext';
import StackableArea from 'components/Shared/StackedContent/StackableArea';
import Portal from 'components/Shared/Portal';
const IntegrationStackedContent = ({ children, isMobile, isProductJourney = false, isPaymentWidget = false, }) => {
    const defaultPage = {
        id: 'default_page',
        renderComponent: (isActivePage) => (React.createElement(Fragment, null, children(isActivePage))),
        isActive: true,
        breadcrumb: null,
        area: StackedArea.PAGE,
        layout: {
            hasBackButton: false,
            hasHeader: false,
            hasHeaderScrollEffect: false,
            hasFooter: true,
        },
    };
    if (isMobile) {
        // The stacked content setup is slightly different for mobile and desktop.
        // Mobile uses the stacked content to always be on top of the rest of the content
        // On Desktop the content can be stacked in StackableArea's which display on top of selected content ( sidebar for example)
        return (React.createElement(StackableContentProvider, null, ({ stackedContents, deactivateStackedContent, activeStackedContent, }) => {
            return (React.createElement(TransitioningPageWrapper, { id: "st-page-wrapper", isIntegration: true },
                React.createElement(PageTransitionContainer, { index: 0, activePage: defaultPage, deactivatePage: deactivateStackedContent, createdBy: undefined, isIntegration: true, isProductJourney: isProductJourney }, defaultPage.renderComponent((activeStackedContent === null || activeStackedContent === void 0 ? void 0 : activeStackedContent.id) === 'default_page')),
                stackedContents.map((stackedContent, index) => {
                    // render the pages inside a modal if it's the verified payment widget
                    if (isPaymentWidget) {
                        return (React.createElement(Portal, { key: `active-page-${stackedContent.id}` },
                            React.createElement(PageTransitionContainer, { index: index + 1, activePage: stackedContent, deactivatePage: deactivateStackedContent, createdBy: undefined, isIntegration: true, isProductJourney: isProductJourney }, stackedContent.renderComponent(stackedContent.id === (activeStackedContent === null || activeStackedContent === void 0 ? void 0 : activeStackedContent.id)))));
                    }
                    else {
                        return (React.createElement(PageTransitionContainer, { key: `active-page-${stackedContent.id}`, index: index + 1, activePage: stackedContent, deactivatePage: deactivateStackedContent, createdBy: undefined, isIntegration: true, isProductJourney: isProductJourney }, stackedContent.renderComponent(stackedContent.id === activeStackedContent.id)));
                    }
                })));
        }));
    }
    return (
    // The desktop stacked content works with the StackableArea's.
    // Every stacked page will be rendered within a Stackable area that matches the area type.
    // Some more info on this can be found in the README.md
    React.createElement(StackableContentProvider, null, () => {
        return (React.createElement(StackableArea, { area: StackedArea.PAGE }, defaultPage.renderComponent()));
    }));
};
export default IntegrationStackedContent;
